/* JellyChic brand behaviour · v6. One IIFE, no dependencies.
   Rules: no layout reads at start-up (measure on user action, in observers, or in a rAF scroll loop), re-init on
   shopify:section:load, never mutate the cart drawer by hand (always re-render it from Shopify's section HTML).
   Motion: only the bag and the media move; UI fades 200–400ms and stops. Everything respects reduced motion.
   Analytics: window.dataLayer gets { event: 'jc_<name>' } for every [data-track] interaction. */
(function () {
  'use strict';
  window.jcReady = true;
  // layout/theme.liquid takes html.jc-js away after 5 s without this script (the no-JS fallback); on a slow phone the
  // script can simply arrive later than that, so it puts the class back
  document.documentElement.classList.add('jc-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lang = document.documentElement.lang || undefined;
  var state = { colour: null, tier: 1 };
  // The few words this script writes itself, in the page's language (window.jcT, from the theme's locale files)
  function T(k, d) { var t = window.jcT; return t && typeof t[k] === 'string' ? t[k] : d; }

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function setText(el, text) { if (el && el.textContent !== text) el.textContent = text; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function buzz() { try { if (navigator.vibrate) navigator.vibrate(10); } catch (e) { /* no-op */ } }
  function store(key, val) { try { if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null'); localStorage.setItem(key, JSON.stringify(val)); } catch (e) { return null; } }
  function onVisible(el, cb, threshold) {
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); cb(); } });
    }, { threshold: threshold || 0.25 });
    io.observe(el);
  }
  function track(name, detail) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: 'jc_' + name, jc_colour: state.colour, jc_bundle: state.tier };
    if (detail) Object.keys(detail).forEach(function (k) { payload[k] = detail[k]; });
    window.jcPush(payload);
  }

  /* Money in the visitor's currency, in the store's own format ("RM410", "$99", "99 €"); whole units unless
     Theme settings → Prices says exact (window.jcNum, layout/theme.liquid). */
  var rate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  function moneyFormatter(sampleText) {
    var prefix = '', suffix = '', grp = ',';
    var m = sampleText && sampleText.match(/^(.*?)(\d[\d.,\s]*\d|\d)(.*)$/);
    if (m) {
      prefix = m[1]; suffix = m[3];
      if (/\.\d{3}/.test(m[2]) && !/,\d{3}/.test(m[2])) grp = '.';
      else if (/\s\d{3}/.test(m[2])) grp = ' ';
      if (window.jcMoneyGrp) grp = window.jcMoneyGrp;   // her currency's own thousands separator (layout/theme.liquid)
    } else if (window.jcMoneyFmt) {
      // no price sample on this page: Shopify's own format for her currency, from layout/theme.liquid
      prefix = window.jcMoneyFmt.pre; suffix = window.jcMoneyFmt.suf; grp = window.jcMoneyFmt.grp;
    } else {
      try { prefix = new Intl.NumberFormat(lang, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' }).format(0).replace(/[\d.,\s]/g, ''); } catch (e) { prefix = currency + ' '; }
    }
    return function (subunits) { return prefix + window.jcNum(subunits, grp) + suffix; };
  }
  var money = moneyFormatter(null);
  function friendly(subunits) {
    var v = subunits / 100;
    var r = v >= 1000 ? Math.round(v / Math.pow(10, Math.floor(Math.log10(v)) - 1)) * Math.pow(10, Math.floor(Math.log10(v)) - 1) : Math.round(v / 10) * 10 || Math.round(v);
    return money(r * 100);
  }
  /* Shop-currency amounts → the visitor's currency. Anchors are "≈" and friendly-rounded; savings are exact. */
  function fillUsd(scope) {
    $$('[data-jc-usd]', scope).forEach(function (el) {
      var cents = parseFloat(el.getAttribute('data-jc-usd')) * rate;
      if (el.hasAttribute('data-jc-minus')) cents = parseFloat(el.getAttribute('data-jc-minus')) - cents;
      if (!isFinite(cents)) return;
      setText(el, el.hasAttribute('data-jc-approx') ? '≈ ' + friendly(cents) : money(cents));
    });
  }

  /* A Shopify CDN image URL at another width */
  function sized(url, w) { return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  /* A colour's cut-out at a small width (the -320 file is the same picture as the big one): faces built here */
  function faceAt(c, w) { var u = (c && (c.cutout || c.face)) || ''; return u ? sized(u.replace(/-320\.png/, '.png'), w) : ''; }

  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function sectionsToRender() {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === 'function') return drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    return 'cart-drawer,cart-icon-bubble';
  }
  function renderCart(json, open) {
    var d = cartDrawer();
    if (!d || typeof d.getSectionsToRender !== 'function') { if (open) window.location.href = (window.routes && window.routes.cart_url) || root + 'cart'; return; }
    if (open && typeof d.renderContents === 'function') { d.classList.remove('is-empty'); d.renderContents(json); return; }
    d.classList.remove('is-empty');
    d.getSectionsToRender().forEach(function (s) {
      var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (el && json.sections && json.sections[s.id]) el.innerHTML = d.getSectionInnerHTML(json.sections[s.id], s.selector);
    });
  }

  /* POST /cart/add.js with one or more lines; re-render the bag (opening it unless open === false). */
  function addLines(lines, trigger, open) {
    var body = { items: lines, sections: sectionsToRender(), sections_url: window.location.pathname };
    var drawer = cartDrawer();
    if (drawer && trigger && drawer.setActiveElement && open !== false && !drawer.classList.contains('active')) drawer.setActiveElement(trigger);
    var events = window.StandardEvents || {};
    var deferred = null;
    if (events.CartLinesUpdateEvent && trigger) {
      try {
        deferred = events.CartLinesUpdateEvent.createPromise();
        trigger.dispatchEvent(new events.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: lines.map(function (l) { return { merchandiseId: String(l.id), quantity: l.quantity }; }), promise: deferred.promise }));
      } catch (e) { deferred = null; }
    }
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().catch(function () { return { status: res.status || 500 }; }).then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        if (!r.ok || r.json.status) {
          var msg = (r.json && (r.json.description || r.json.message)) || T('error_generic', 'Something went wrong. Please try again.');
          if (deferred) deferred.reject(new Error(msg));
          throw new Error(msg);
        }
        if (deferred) fetch(root + 'cart.js').then(function (x) { return x.json(); }).then(function (cart) { try { deferred.resolve({ cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart) }); } catch (e) { /* analytics only */ } }).catch(function () {});
        if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'jc', cartData: r.json });
        try { renderCart(r.json, open !== false); } catch (e) { if (open !== false) window.location.href = (window.routes && window.routes.cart_url) || root + 'cart'; }
        return r.json;
      });
  }

  /* For section scripts on any page: add lines (opens the bag), the page toast, the fly-to-bag */
  window.jcCart = {
    add: function (lines, trigger, open) { return addLines(lines, trigger, open); },
    flash: function (text, isError) { flash(text, isError); },
    fly: function (fromEl, src) { flyToCart(fromEl, src); }
  };

  function flyToCart(fromEl, src) {
    var target = document.getElementById('cart-icon-bubble');
    if (reduceMotion || !fromEl || !target || !src || !fromEl.getBoundingClientRect || !document.body.animate) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || b.bottom < 0) return;
    var fly = document.createElement('span');
    fly.className = 'jc-fly';
    fly.innerHTML = '<img src="' + src + '" alt="">';
    fly.style.left = (a.left + a.width / 2 - 22) + 'px';
    fly.style.top = (a.top + a.height / 2 - 22) + 'px';
    document.body.appendChild(fly);
    var dx = (b.left + b.width / 2) - (a.left + a.width / 2), dy = (b.top + b.height / 2) - (a.top + a.height / 2);
    fly.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.55 - 60) + 'px) scale(0.9)', opacity: 1, offset: 0.55 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.3)', opacity: 0.2 }], { duration: 650, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { fly.remove(); };
  }

  /* A message at the bottom of the screen, for adds made away from the fold (sticky bar, inline buttons, the bag) */
  var flashTimer = null;
  function flash(text, isError) {
    var el = document.querySelector('[data-jc-flash]');
    if (!el) {
      el = document.createElement('p');
      el.className = 'jc-toast jc-flash';
      el.setAttribute('data-jc-flash', '');
      el.setAttribute('role', 'alert');
      el.hidden = true;
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.toggle('is-error', !!isError);
    el.hidden = false;
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { el.hidden = true; }, isError ? 5000 : 2400);
  }

  var toastTimer = null;
  function toast(text, where) {
    var t = (where && $('[data-jc-toast]', where)) || $('[data-jc-toast]');
    if (!t) return;
    t.textContent = text;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2200);
  }

  /* ---------- The page wears the colour ---------- */
  var buy = null;   // the fold's controller (initBuy)
  var heroModel = '';   // the model's name for the main photo's alt text (the buy box's data)
  function applyColour(c, animate) {
    if (!c) return;
    var changed = state.colour !== null && state.colour !== c.slug;
    state.colour = c.slug;
    function paint() {
      if (c.hex) document.documentElement.style.setProperty('--sw', c.hex);
      $$('[data-jc-colour-name]').forEach(function (el) { setText(el, c.name); });
      // Responsive swap (window.jcSetImg, layout/theme.liquid): the size on screen, not the 1200 px original
      $$('[data-jc-cutout]').forEach(function (img) {
        if (!c.cutout) return;
        img.onerror = function () { img.onerror = null; if (c.image) { img.removeAttribute('srcset'); img.src = c.image; } };
        window.jcSetImg(img, c.cutout);
      });
      $$('[data-jc-face]').forEach(function (img) { if (c.face) window.jcSetImg(img, c.face); });
      // The owner's hero photo for this colour (slide 1 and its thumbnail)
      if (c.image) $$('[data-jc-hero]').forEach(function (w) {
        if (w.getAttribute('data-jc-hero') === c.slug) return;
        var img = $('img', w);
        if (!img) return;
        w.setAttribute('data-jc-hero', c.slug);
        // the same size steps as the section prints for the first colour (sections/jc-product: the hero's widths)
        img.srcset = [390, 540, 640, 720, 780, 860, 960, 1080, 1400].map(function (px) { return sized(c.image, px) + ' ' + px + 'w'; }).join(', ');
        img.src = sized(c.image, 1080);
        img.alt = T('hero_alt', '[model] in [colour]').replace('[model]', heroModel || (img.alt || '').replace(/ in .*$/, '')).replace('[colour]', c.name);
      });
      if (c.thumb) $$('[data-jc-hero-thumb]').forEach(function (w) {
        if (w.getAttribute('data-jc-hero-thumb') === c.slug) return;
        var img = $('img', w);
        if (!img) return;
        w.setAttribute('data-jc-hero-thumb', c.slug);
        img.removeAttribute('srcset');
        img.src = c.thumb;
      });
      $$('[data-jc-strip]').forEach(function (b) {
        var on = b.getAttribute('data-jc-strip') === c.slug;
        b.classList.toggle('is-on', on);
        if (b.tagName === 'BUTTON') { if (on) b.setAttribute('aria-pressed', 'true'); else b.removeAttribute('aria-pressed'); }
      });
      $$('[data-jc-best-flag]').forEach(function (el) { el.hidden = !c.best; });
      $$('[data-jc-save-tags]').forEach(function (inp) { inp.value = 'newsletter,saved-' + c.slug; });
      $$('[data-jc-lineup]').forEach(function (stage) { lineupSelect(stage, c.slug, changed); });
    }
    if (animate && changed && !reduceMotion && document.startViewTransition) document.startViewTransition(paint);
    else paint();
  }

  /* ---------- The fold: colour, the set (1 up to maxBags bags), Add to bag ---------- */
  function initBuy(scope) {
    var dataEl = $('[data-jc-buy-data]', scope);
    var form = $('[data-jc-bundle]', scope);
    if (!dataEl || !form || form.dataset.jcInit) return;
    form.dataset.jcInit = '1';
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var product = form.closest('product-component') || scope;
    var sid = data.section;
    heroModel = data.model || '';
    money = moneyFormatter(data.unitText);
    if (data.currency && data.shopCurrency && data.currency === data.shopCurrency) rate = 1;

    var colours = {};
    (data.colours || []).forEach(function (c) { colours[c.slug] = c; });
    if (!colours[data.current.slug]) colours[data.current.slug] = data.current;
    Object.keys(colours).forEach(function (k) { colours[k].best = (data.bestsellers || []).indexOf(k) > -1; });
    // Sale prices only when the owner turns them on (the variants carry compare-at prices already)
    if (!data.showCompare) Object.keys(colours).forEach(function (k) { colours[k].compare = 0; });
    var complements = {};
    (data.complements || '').split(/\n/).forEach(function (l) {
      var p = l.split(':');
      if (p.length > 1) complements[p[0].trim()] = p[1].split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    });
    var offs = data.offs || {};
    var maxBags = Math.max(3, parseInt(data.maxBags, 10) || 11);
    /* The set discounts (they must match Shopify's "Set price" automatic discounts): 2 bags → the 2-bag amount;
       3 or more → the 3-bag amount's share on every bag (owner, 5 Oct 2026: $99 − $16 = $83 each). If offs.x is
       set (Theme settings, "From the 4th bag"), each bag from the 4th gets offs.x off instead. Shown in the
       visitor's currency. */
    function off(n) { return window.jcSetOff(offs, n, rate); }   // bag by bag, like checkout (layout/theme.liquid)
    var addBtn = $('[data-jc-add]', form);
    var addLabel = $('[data-jc-add-label]', form);
    var errorEl = $('[data-jc-error]', product);
    var sticky = $('[data-jc-sticky]', product);

    /* Bag 1 is the colour chips (radios); bags 2..N live here. */
    var count = 1, extra = [], touched = [];
    function input1(slug) { return $('input[name="jc-slot-' + sid + '-1"][value="' + slug + '"]', product); }
    function slotSlug(n) {
      if (n === 1) { var c = $('input[name="jc-slot-' + sid + '-1"]:checked', product); return c ? c.value : data.current.slug; }
      return extra[n - 2] || slotSlug(1);
    }
    function card() { return Math.min(count, 3); }
    function tier() { return count; }
    function colour(slug) { return colours[slug] || data.current; }
    function slotsFor(n) { var out = []; for (var i = 1; i <= n; i++) out.push(colour(slotSlug(i))); return out; }
    function totalFor(n) { return slotsFor(n).reduce(function (s, c) { return s + c.price; }, 0) - off(n); }
    /* What the same bags cost before any saving: the compare-at price when a colour is on sale */
    function refFor(list) { return list.reduce(function (s, c) { return s + (c.compare > c.price ? c.compare : c.price); }, 0); }
    function onSale(list) { return list.some(function (c) { return c.compare > c.price; }); }
    /* What each extra bag costs once she has 3: the 4th-bag price when set, else the 3-bag share */
    function eachFrom3(c) { return c.price - Math.round((offs.x ? offs.x : (offs['3'] || 0) / 3) * rate); }
    function names(list) {
      var n = list.map(function (c) { return c.name; });
      return n.length > 3 ? n.slice(0, 3).join(' + ') + ' +' + (n.length - 3) : n.join(' + ');
    }
    function label(tpl, n) { return (tpl || 'Bag [n]').replace('[n]', String(n)); }

    /* Bags 2..N follow bag 1's complements, then the bestsellers, then the list, unless she picked them herself (her
       pick always stays, even a repeat). A bag she hasn't touched never repeats a colour until all eleven are used. */
    function prefill() {
      var upto = Math.max(count, 3);
      var first = slotSlug(1);
      var want = (complements[first] || []).concat(data.bestsellers || [], Object.keys(colours)).filter(function (w) { return colours[w] && colours[w].available !== false; });
      var used = [first], n;
      for (n = 2; n <= upto; n++) if (touched[n] && extra[n - 2]) used.push(extra[n - 2]);
      for (n = 2; n <= upto; n++) {
        if (touched[n] && extra[n - 2]) continue;
        var pick = null;
        for (var i = 0; i < want.length; i++) if (used.indexOf(want[i]) === -1) { pick = want[i]; break; }
        if (!pick) pick = want.length ? want[(n - 2) % want.length] : first;
        extra[n - 2] = pick;
        used.push(pick);
      }
    }

    function comp(el, list) {
      // The same size steps as the colour chips (snippets/jc-bag), so these small bags reuse the chips' files; they wait
      // for the main picture like the chips do (data-jc-hold, layout/theme.liquid)
      var html = list.map(function (c) {
        var ss = faceAt(c, 160) ? ' srcset="' + [96, 128, 160, 192].map(function (w) { return faceAt(c, w) + ' ' + w + 'w'; }).join(', ') + '" sizes="auto, 64px"' : '';
        return '<img src="' + faceAt(c, 160) + '"' + ss + ' alt="" width="160" height="160" loading="lazy" data-jc-hold>';
      }).join('');
      if (el.dataset.jcCompHtml !== html) { el.dataset.jcCompHtml = html; el.innerHTML = html; }
      el.classList.remove('jc-comp--1', 'jc-comp--2', 'jc-comp--3');
      el.classList.add('jc-comp', 'jc-comp--' + list.length);
    }

    /* The marginal discount on the 2nd / 3rd bag, calculated from the discounts (never typed) */
    function pct(n, unitPrice) {
      if (!unitPrice) return 0;
      return Math.round((n === 2 ? off(2) : off(3) - off(2)) / unitPrice * 100);
    }

    /* Bag cells: 1–3 come from Liquid; 4 and up are copies of cell 3 with a remove button */
    var setEl = $('[data-jc-set]', form);
    var slotsWrap = $('[data-jc-set-slots]', form);
    var moreCell = slotsWrap && $('.jc-set__cell--more', slotsWrap);
    var tplCell = slotsWrap && $('[data-jc-cell="3"]', slotsWrap);
    var closeSvg = $('[data-jc-cpick] .jc-drawer__x svg', product);
    function syncCells() {
      if (!slotsWrap || !tplCell) return;
      $$('[data-jc-cell]', slotsWrap).forEach(function (cell) { if (parseInt(cell.getAttribute('data-jc-cell'), 10) > Math.max(3, count)) cell.remove(); });
      for (var n = 4; n <= count; n++) {
        if ($('[data-jc-cell="' + n + '"]', slotsWrap)) continue;
        var cell = tplCell.cloneNode(true);
        cell.setAttribute('data-jc-cell', String(n));
        cell.className = 'jc-set__cell jc-set__cell--x';
        $('[data-jc-slot-open]', cell).setAttribute('data-jc-slot-open', String(n));
        $('[data-jc-slot-open]', cell).classList.remove('is-pop');
        $('[data-jc-slot-label]', cell).setAttribute('data-jc-slot-label', String(n));
        $('[data-jc-slot-swatch]', cell).setAttribute('data-jc-slot-swatch', String(n));
        // The copy's picture starts clean: no memory of cell 3's colour, and nothing half-kept from a picture that was
        // waiting when it was copied (the theme's parking, or Shopify's sizes="auto" helper on Safari and Firefox, which
        // would write cell 3's colour back at the first paint). update() paints its own colour right after.
        var ci = $('[data-jc-slot-swatch] img', cell);
        if (ci) ['data-jc-base', 'data-jc-parked', 'data-auto-sizes-src', 'data-auto-sizes-srcset'].forEach(function (a) { ci.removeAttribute(a); });
        setText($('.jc-set__no', cell), label(data.slotLabel, n));
        var x = document.createElement('button');
        x.type = 'button';
        x.className = 'jc-set__x';
        x.setAttribute('data-jc-slot-remove', String(n));
        x.setAttribute('data-track', 'set_remove');
        x.setAttribute('aria-label', label(data.removeLabel || 'Remove bag [n]', n));
        if (closeSvg) x.appendChild(closeSvg.cloneNode(true)); else x.textContent = '×';
        cell.appendChild(x);
        slotsWrap.insertBefore(cell, moreCell || null);
      }
    }
    function pop(n) {
      var b = $('[data-jc-slot-open="' + n + '"]', form);
      if (!b || reduceMotion) return;
      b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
    }

    /* Mirrors of the set further down the page (the final call): the same bags, tap one to change its colour,
       "+" to add one. Rendered from the same state, so the fold and the mirrors are always the same set. */
    var penHtml = ($('.jc-set__pen', form) || {}).innerHTML || '';
    var plusHtml = ($('.jc-set__img--more', form) || {}).innerHTML || '+';
    function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch]; }); }
    function renderMirrors(t, first) {
      var boxes = $$('[data-jc-mirror-slots]');
      if (!boxes.length) return;
      var list = slotsFor(t);
      var xHtml = closeSvg ? closeSvg.outerHTML : '×';
      boxes.forEach(function (box) {
        var more = '', moreSub = '';
        if (t < maxBags) {
          var nextList = slotsFor(Math.min(3, t + 1));
          if (t === 1) more = box.getAttribute('data-jc-mirror-first') || data.addLabel || 'Add a bag';
          else if (t === 2) more = data.moreLabel || 'Make it 3';
          else more = data.addLabel || 'Add a bag';
          moreSub = t < 3 ? String(data.saveLabel || 'Save [saving]').replace('[saving]', money(refFor(nextList) - totalFor(nextList.length))) : String(data.eachLabel || '[each] each').replace('[each]', money(eachFrom3(first)));
        }
        var sig = t + '|' + list.map(function (c) { return c.slug; }).join(',') + '|' + more + '|' + moreSub;
        if (box.dataset.sig === sig) return;
        box.dataset.sig = sig;
        box.innerHTML = list.map(function (c, i) {
          var n = i + 1, nm = label(data.slotLabel, n);
          return '<div class="jc-set__cell' + (n > 3 ? ' jc-set__cell--x' : '') + '">' +
            '<button type="button" class="jc-set__slot" data-jc-mslot="' + n + '" data-track="final_slot_open" style="--c: ' + esc(c.hex || '#ddd') + ';" aria-label="' + esc(T('slot_aria', '[slot]: [colour]. [change]').replace('[slot]', nm).replace('[colour]', c.name).replace('[change]', data.slotChange || '')) + '">' +
            '<span class="jc-set__img"><img src="' + esc(faceAt(c, 240)) + '" alt="" width="240" height="240" loading="lazy"><i class="jc-set__pen" aria-hidden="true">' + penHtml + '</i></span>' +
            '<span class="jc-set__no">' + esc(nm) + '</span><span class="jc-set__name">' + esc(c.name) + '</span></button>' +
            (n > 3 ? '<button type="button" class="jc-set__x" data-jc-mslot-remove="' + n + '" data-track="set_remove" aria-label="' + esc(label(data.removeLabel || 'Remove bag [n]', n)) + '">' + xHtml + '</button>' : '') +
            '</div>';
        }).join('') + (more ? '<div class="jc-set__cell jc-set__cell--more"><button type="button" class="jc-set__slot jc-set__more" data-jc-mslot-more data-track="final_set_more"><span class="jc-set__img jc-set__img--more">' + plusHtml + '</span><span class="jc-set__no">' + esc(more) + '</span><span class="jc-set__name jc-set__name--save">' + esc(moreSub) + '</span></button></div>' : '');
      });
    }
    function mirrorPop(n, box) {
      $$(box ? '[data-jc-mslot="' + n + '"]' : '[data-jc-mirror-slots] [data-jc-mslot="' + n + '"]', box || document).forEach(function (b) {
        if (reduceMotion) return;
        b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
      });
    }
    var lastCard = null;

    function update(animate) {
      var t = count, cd = card();
      state.tier = t;
      form.setAttribute('data-tier', String(cd));
      form.setAttribute('data-count', String(t));
      var first = colour(slotSlug(1));
      syncCells();

      // The three rows (row 3 is "3 or more": it shows the set she's building)
      for (var n = 1; n <= 3; n++) {
        var k = n === 3 ? Math.max(3, t) : n;
        var list = slotsFor(k), total = totalFor(k), ref = refFor(list), saving = ref - total, sale = onSale(list);
        $$('[data-jc-tier-price="' + n + '"]').forEach(function (el) { setText(el, money(total)); });
        $$('[data-jc-tier-was="' + n + '"]').forEach(function (el) { el.hidden = !sale; setText(el, sale ? money(ref) : ''); });
        $$('[data-jc-tier-save="' + n + '"]').forEach(function (el) { setText(el, saving >= 50 && data.saveLabel ? data.saveLabel.replace('[saving]', money(saving)) : ''); });
        $$('[data-jc-comp="' + n + '"]').forEach(function (el) { comp(el, list.slice(0, n)); });
        var sub = (data.subs && data.subs[n]) || '';
        if (n === 3 && t > 3 && data.familySub) sub = data.familySub.replace('[n]', String(t)).replace('[each]', money(eachFrom3(first)));
        else if (sub.indexOf('[pct]') > -1) { var p = n > 1 ? pct(n, first.price) : 0; sub = p > 0 ? sub.replace('[pct]', p + '%') : sub.split(' · ')[0]; }
        $$('[data-jc-tier-sub="' + n + '"]').forEach(function (el) { setText(el, sub); });
      }
      $$('[data-jc-tier-plus]').forEach(function (el) { el.hidden = t <= 3; setText(el, t > 3 ? '+' + (t - 3) : ''); });
      $$('[data-jc-tier-proxy]').forEach(function (b) { b.setAttribute('aria-checked', String(parseInt(b.getAttribute('data-jc-tier-proxy'), 10) === cd)); });

      // The bags in the set: face, name, tint
      for (var s = 1; s <= Math.max(3, t); s++) {
        var sc = colour(slotSlug(s));
        var btn = $('[data-jc-slot-open="' + s + '"]', form);
        if (!btn) continue;
        btn.style.setProperty('--c', sc.hex || '#ddd');
        btn.setAttribute('aria-label', T('slot_aria', '[slot]: [colour]. [change]').replace('[slot]', label(data.slotLabel, s)).replace('[colour]', sc.name).replace('[change]', data.slotChange || ''));
        setText($('[data-jc-slot-label="' + s + '"]', btn), sc.name);
        var fimg = $('[data-jc-slot-swatch] img', btn);
        if (fimg && sc.face) window.jcSetImg(fimg, sc.face);
      }
      // The "+" tile: "Make it 3 · Save RM198" with two bags; "Add a bag · RM344 each" from three up
      if (moreCell) {
        moreCell.hidden = t >= maxBags;
        setText($('[data-jc-set-more-label]', moreCell), t === 2 ? data.moreLabel : data.addLabel);
        var three = slotsFor(3);
        setText($('[data-jc-set-more-sub]', moreCell), t === 2 ? (data.saveLabel || '[saving]').replace('[saving]', money(refFor(three) - totalFor(3))) : (data.eachLabel || '[each] each').replace('[each]', money(eachFrom3(first))));
      }
      var now = slotsFor(t), nowTotal = totalFor(t), nowSaving = refFor(now) - nowTotal;
      $$('[data-jc-set-save]', form).forEach(function (el) { setText(el, t > 1 && nowSaving >= 50 && data.setSave ? data.setSave.replace('[saving]', money(nowSaving)) : ''); });
      $$('[data-jc-mirror-save]').forEach(function (el) { setText(el, t > 1 && nowSaving >= 50 && data.setSave ? data.setSave.replace('[saving]', money(nowSaving)) : ''); });
      renderMirrors(t, first);
      if (setEl && lastCard !== null && cd !== lastCard && cd > 1 && !reduceMotion) { setEl.classList.remove('is-fresh'); void setEl.offsetWidth; setEl.classList.add('is-fresh'); }
      lastCard = cd;

      // Real, tracked stock only
      var stockEl = $('[data-jc-stock]', product);
      if (stockEl) {
        var q = data.stock && data.stock[String(first.variant)];
        stockEl.hidden = !q;
        if (q) setText(stockEl, (data.stockLabel || 'Only [n] left').replace('[n]', String(q)).replace('[colour]', first.name));
      }
      // Price: the original struck through, then the sale price (only when the variant has a compare-at price)
      var firstSale = first.compare > first.price;
      $$('[data-jc-was]', product).forEach(function (w) { w.hidden = !firstSale; setText($('[data-jc-was-amt]', w), firstSale ? money(first.compare) : ''); });
      $$('[data-jc-unit]').forEach(function (el) { setText(el, money(first.price)); el.classList.toggle('is-sale', firstSale); });
      applyColour(first, animate);

      var fb = $('[data-jc-fallback-id]', form);
      if (fb) fb.value = first.variant;
      var available = now.every(function (c) { return c.available; });
      var lbl = !available ? (data.soldOut || 'Sold out') : String((t > 2 ? data.buttonLabelMulti : t === 2 ? (data.buttonLabelDuo || data.buttonLabelMulti) : data.buttonLabel) || 'Add to bag').replace('[price]', money(nowTotal)).replace('[count]', String(t));
      if (!addBtn.classList.contains('is-added')) setText(addLabel, lbl);
      addBtn.disabled = !available;
      $$('[data-jc-final-label]').forEach(function (el) { setText(el, lbl); });
      var inlineMulti = String(data.inlineLabelMulti || 'Add [count] bags');
      var inline = t > 2 ? inlineMulti.replace('[colours]', names(now)).replace('[count]', String(t)) : t === 2 ? (data.buttonLabelDuo || inlineMulti.replace('[colours]', names(now)).replace('[count]', '2')) : String(data.inlineLabel || 'Add [colour]').replace('[colour]', first.name);
      $$('[data-jc-inline-text]').forEach(function (el) { setText(el, inline); });
      if (sticky) {
        setText($('[data-jc-sticky-name]', sticky), (t > 1 ? names(now) : first.name) + ' · ' + data.names[cd]);
        setText($('[data-jc-sticky-price]', sticky), money(nowTotal));
        setText($('[data-jc-sticky-label]', sticky), available ? lbl : data.soldOut);
      }
      // Colour and set in the URL and for the next visit
      var u = new URL(window.location.href);
      u.searchParams.set('colour', first.slug);
      if (t > 1) u.searchParams.set('bundle', String(t)); else u.searchParams.delete('bundle');
      if (data.variantsMode) u.searchParams.set('variant', first.variant);
      u.searchParams.delete('with');   // read once at start (below); the address keeps colour and set only, as before
      if (u.toString() !== window.location.href && history.replaceState) history.replaceState(history.state, '', u.toString());
      store('jc-sel', { colour: first.slug, bundle: t, t: Date.now() });
    }

    /* After she picks 2 or more bags, keep the bags under the row in view (the sticky bar covers the bottom 64px) */
    function revealSet(el) {
      el = el || setEl;
      if (!el || count < 2) return;
      setTimeout(function () {
        var r = el.getBoundingClientRect();
        var room = window.innerHeight - (window.innerWidth < 1024 ? 88 : 24);
        if (r.bottom > room && r.top > 0) window.scrollBy({ top: Math.min(r.bottom - room, r.top - 80), behavior: reduceMotion ? 'auto' : 'smooth' });
      }, reduceMotion ? 0 : 320);
    }
    function setCount(n, why) {
      n = clamp(n, 1, maxBags);
      if (n === count && why !== 'init') return;
      count = n;
      var r = $('[data-jc-tier="' + card() + '"]', form);
      if (r) r.checked = true;
      prefill();
    }
    function addBag() {
      if (count >= maxBags) return;
      setCount(count + 1);
      update(true);
      buzz();
      track('set_add', { bags: count });
      pop(count);
      revealSet($('[data-jc-cell="' + count + '"]', form) || setEl);
    }
    function removeBag(n) {
      if (n < 4 || n > count) return;
      extra.splice(n - 2, 1);
      touched.splice(n, 1);
      count -= 1;
      prefill();
      update(true);
      buzz();
      track('set_remove', { bags: count });
      var next = $('[data-jc-slot-open="' + Math.min(n, count) + '"]', form);
      if (next) next.focus({ preventScroll: true });
    }

    product.addEventListener('change', function (e) {
      var n = e.target && e.target.name;
      if (!n || n.indexOf('jc-') !== 0) return;
      if (n === 'jc-slot-' + sid + '-1') { prefill(); buzz(); track('colour_select', { colour: e.target.value }); update(true); return; }
      if (n.indexOf('jc-tier-') === 0) {
        setCount(parseInt(e.target.value, 10));
        buzz();
        track('bundle_select', { bundle: count });
        update(true);
        revealSet();
      }
    });

    /* The colour sheet for any bag: tap a bag in the set, tap a colour, done */
    var sheet = $('[data-jc-cpick]', product);
    var sheetSlot = 2;
    var sheetBox = null;
    function openSheet(n, from) {
      if (!sheet || typeof sheet.showModal !== 'function') return;
      sheetSlot = n;
      sheetBox = from && from.closest ? from.closest('[data-jc-mirror-slots]') : null;
      setText($('[data-jc-cpick-title]', sheet), label(data.cpickTitle, n));
      var cur = slotSlug(n), usedBy = {};
      for (var i = 1; i <= count; i++) { if (i === n) continue; var us = slotSlug(i); (usedBy[us] = usedBy[us] || []).push(label(data.slotLabel, i)); }
      $$('[data-jc-cpick-colour]', sheet).forEach(function (b) {
        var slug = b.getAttribute('data-jc-cpick-colour');
        b.setAttribute('aria-pressed', slug === cur ? 'true' : 'false');
        var tags = usedBy[slug] || [];
        setText($('[data-jc-cpick-in]', b), tags.length > 2 ? tags.slice(0, 2).join(' · ') + ' +' + (tags.length - 2) : tags.join(' · '));
      });
      sheet.showModal();
      track('set_sheet_open', { slot: n });
    }
    if (sheet) sheet.addEventListener('click', function (e) {
      var b = e.target.closest('[data-jc-cpick-colour]');
      if (!b || b.disabled) return;
      var slug = b.getAttribute('data-jc-cpick-colour'), n = sheetSlot;
      if (n === 1) { var inp = input1(slug); if (!inp || inp.disabled) return; inp.checked = true; }
      else { extra[n - 2] = slug; for (var k = 2; k <= count; k++) touched[k] = true; }
      prefill();
      $$('[data-jc-cpick-colour]', sheet).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      buzz();
      track('set_colour', { slot: n, colour: slug });
      update(n === 1);
      setTimeout(function () {
        if (sheet.open) sheet.close();
        var mb = sheetBox && $('[data-jc-mslot="' + n + '"]', sheetBox);
        if (mb) { mb.focus({ preventScroll: true }); mirrorPop(n, sheetBox); return; }
        var slotBtn = $('[data-jc-slot-open="' + n + '"]', form);
        if (slotBtn) slotBtn.focus({ preventScroll: true });
        pop(n);
      }, reduceMotion ? 0 : 220);
    });
    form.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-jc-slot-remove]');
      if (rm) { e.preventDefault(); removeBag(parseInt(rm.getAttribute('data-jc-slot-remove'), 10)); return; }
      var so = e.target.closest('[data-jc-slot-open]');
      if (so) { e.preventDefault(); openSheet(parseInt(so.getAttribute('data-jc-slot-open'), 10)); return; }
      if (e.target.closest('[data-jc-set-more]')) {
        e.preventDefault();
        if (count < 3) { buy.setTier(3); pop(3); revealSet(); } else addBag();
      }
    });

    function faceSrc() { var c = colour(slotSlug(1)); return c.face || c.cutout; }
    function added(trigger) {
      buzz();
      flyToCart(trigger, faceSrc());
      var face = sticky && $('[data-jc-sticky-face]', sticky);
      if (face) { face.classList.remove('is-wink'); void face.offsetWidth; face.classList.add('is-wink'); }
      addBtn.classList.add('is-added');
      setText(addLabel, data.addedLabel);
      setTimeout(function () { addBtn.classList.remove('is-added'); update(false); }, 600);
      try { document.dispatchEvent(new CustomEvent('jc:added', { detail: { trigger: trigger || addBtn } })); } catch (e) { /* old browsers */ }
    }

    function submit(trigger, name) {
      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return Promise.resolve();
      var t = count;
      var q = {}, order = [];
      slotsFor(t).forEach(function (c) { if (!q[c.variant]) { q[c.variant] = 0; order.push(c.variant); } q[c.variant] += 1; });
      if (errorEl) errorEl.hidden = true;
      var from = trigger || addBtn;
      addBtn.setAttribute('aria-disabled', 'true');
      addBtn.classList.add('is-loading');
      from.classList.add('is-loading');
      track(name || 'atc', { bags: t });
      return addLines(order.map(function (id) { return { id: id, quantity: q[id] }; }), from)
        .then(function () { added(from); })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          if (from !== addBtn) flash(err.message, true);
        })
        .finally(function () { addBtn.removeAttribute('aria-disabled'); addBtn.classList.remove('is-loading'); from.classList.remove('is-loading'); });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); submit(addBtn); });
    if (sticky) {
      var sb = $('[data-jc-sticky-add]', sticky);
      if (sb) sb.addEventListener('click', function () { submit(sb, 'sticky_atc'); });
    }

    buy = {
      submit: submit,
      pick: function (slug, animate) {
        var inp = input1(slug);
        if (!inp || inp.disabled) return false;
        inp.checked = true;
        prefill();
        update(animate !== false);
        buzz();
        return true;
      },
      setTier: function (n) {
        setCount(n);
        update(true);
        track('bundle_select', { bundle: count });
      },
      colour: colour,
      openSheet: function (n, from) { openSheet(n, from); },
      more: function () {
        if (count >= maxBags) return;
        setCount(count + 1);
        update(true);
        buzz();
        track('set_add', { bags: count, source: 'final' });
        mirrorPop(count);
      },
      remove: function (n) { removeBag(n); },
      addColour: function (slug, trigger, open) {
        var c = colour(slug);
        if (!c || !c.variant) return Promise.resolve();
        return addLines([{ id: c.variant, quantity: 1 }], trigger, open).then(function () {
          buzz();
          if (open !== false) flyToCart(trigger, c.face);
          return c;
        });
      },
      atc: addBtn
    };

    // Returning visitors and shared links: ?colour=&bundle= first, then the last visit (when the URL doesn't choose).
    // A one-colour product page (an ad lander) is its own choice: it lands on its colour, one bag, whatever she
    // picked on an earlier visit.
    var u = new URL(window.location.href);
    var saved = data.variantsMode === false ? null : store('jc-sel');
    var wantColour = u.searchParams.get('colour') || (!u.searchParams.get('variant') && saved && saved.colour) || null;
    var wantTier = parseInt(u.searchParams.get('bundle') || (saved && !u.searchParams.get('colour') && !u.searchParams.get('variant') ? saved.bundle : 1) || 1, 10);
    if (wantColour && colours[wantColour]) { var wi = input1(wantColour); if (wi && !wi.disabled) wi.checked = true; }
    // A link can also choose the other bags: &with=lilas (bag 2) or &with=lilas,noir (bags 2 and 3). The gift guide's
    // "hers and yours" arrives as she picked it; a colour that is sold out or unknown is skipped and the usual
    // suggestion fills that bag. They count as her own picks, so they stay when she changes bag 1.
    (u.searchParams.get('with') || '').split(',').forEach(function (s, i) {
      s = s.trim().toLowerCase();
      if (i < maxBags - 1 && colours[s] && colours[s].available !== false) { extra[i] = s; touched[i + 2] = true; }
    });
    setCount(isFinite(wantTier) ? wantTier : 1, 'init');
    update(false);
    initSticky(product, addBtn, sticky);
    // "Add <colour>" buttons on reviews and elsewhere never offer a colour that's sold out
    $$('[data-jc-add-colour]').forEach(function (b) { var c = colours[b.getAttribute('data-jc-add-colour')]; if (c && c.available === false) b.hidden = true; });
  }

  /* ---------- Sticky bar: shows when the fold's button is off screen, hides over the footer ---------- */
  function initSticky(product, addBtn, sticky) {
    if (!sticky || !('IntersectionObserver' in window)) return;
    var mainVisible = true, footVisible = false, finalVisible = false;
    // Phones: from the first screen (she can buy without scrolling). Desktop: only once she has scrolled.
    var wide = window.matchMedia('(min-width: 1024px)');
    var scrolled = window.scrollY > 240;
    if (window.__jcStickyScroll) window.removeEventListener('scroll', window.__jcStickyScroll);
    window.__jcStickyScroll = function () { if (!sticky.isConnected) return; var s = window.scrollY > 240; if (s !== scrolled) { scrolled = s; render(); } };
    window.addEventListener('scroll', window.__jcStickyScroll, { passive: true });
    function render() {
      var show = !mainVisible && !footVisible && !finalVisible && (!wide.matches || scrolled);
      sticky.classList.toggle('is-shown', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = $('[data-jc-sticky-add]', sticky);
      if (btn) btn.tabIndex = show ? 0 : -1;
    }
    new IntersectionObserver(function (es) { es.forEach(function (e) { mainVisible = e.isIntersecting; }); render(); }).observe(addBtn);
    var foot = $('.jc-foot');
    if (foot) new IntersectionObserver(function (es) { es.forEach(function (e) { footVisible = e.isIntersecting; }); render(); }).observe(foot);
    var fin = $('[data-jc-final-cta]');
    if (fin) new IntersectionObserver(function (es) { es.forEach(function (e) { finalVisible = e.isIntersecting; }); render(); }).observe(fin);
  }

  /* ---------- Desktop: the buy column scrolls with the page and sticks once its end is in view ---------- */
  function initBuyCol(scope) {
    // Both columns: whichever is shorter sticks once its end is in view, so the page scrolls as one
    [['.jc-buycol', '--jc-buy-h'], ['.jc-gal', '--jc-gal-h']].forEach(function (pair) {
      $$(pair[0], scope).forEach(function (col) {
        if (col.dataset.jcColInit || !('ResizeObserver' in window)) return;
        col.dataset.jcColInit = '1';
        new ResizeObserver(function (es) { es.forEach(function (e) { col.style.setProperty(pair[1], Math.ceil(e.contentRect.height) + 'px'); }); }).observe(col);
      });
    });
  }

  /* ---------- Reviews under the button: arrows on desktop ---------- */
  function initProof(scope) {
    $$('[data-jc-proof]', scope).forEach(function (box) {
      if (box.dataset.jcInit) return;
      box.dataset.jcInit = '1';
      var list = $('[data-jc-proof-cards]', box);
      var btns = $$('[data-jc-proof-go]', box);
      if (!list || !btns.length) return;
      function edges() {
        var max = list.scrollWidth - list.clientWidth - 2;
        btns.forEach(function (b) { b.disabled = parseInt(b.getAttribute('data-jc-proof-go'), 10) < 0 ? list.scrollLeft <= 2 : list.scrollLeft >= max; });
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          var first = list.firstElementChild;
          var step = first ? first.getBoundingClientRect().width + 10 : list.clientWidth;
          list.scrollBy({ left: step * parseInt(b.getAttribute('data-jc-proof-go'), 10), behavior: reduceMotion ? 'auto' : 'smooth' });
          track('proof_arrow');
        });
      });
      var raf = null;
      list.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(function () { raf = null; edges(); }); }, { passive: true });
      onVisible(box, edges, 0.1);
    });
  }

  /* ---------- Real size: on you (height + carry), next to your things, actual size ---------- */
  function ftIn(cm) { var inch = Math.round(cm / 2.54); return Math.floor(inch / 12) + '′' + (inch % 12) + '″'; }
  function initReal(scope) {
    $$('[data-jc-real]', scope).forEach(function (box) {
      if (box.dataset.jcRealInit) return;
      box.dataset.jcRealInit = '1';
      var tabs = $$('[data-jc-real-tab]', box), panes = $$('[data-jc-real-pane]', box);
      function show(k, focus) {
        tabs.forEach(function (t) { var on = t.getAttribute('data-jc-real-tab') === k; t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1; if (on && focus) t.focus(); });
        panes.forEach(function (p) { p.hidden = p.getAttribute('data-jc-real-pane') !== k; });
        track('real_view', { view: k });
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-jc-real-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var j = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
          show(tabs[j].getAttribute('data-jc-real-tab'), true);
        });
      });

      var you = $('[data-jc-you]', box);
      if (!you) return;
      var range = $('[data-jc-you-range]', you), out = $('[data-jc-you-out]', you), rule = $('[data-jc-you-rule]', you);
      var bag = $('[data-jc-you-bag]', you), tag = $('[data-jc-you-tag]', you), note = $('[data-jc-you-note]', you);
      var front = $('[data-jc-strap-front]', you), back = $('[data-jc-strap-back]', you);
      var bagCm = (parseFloat(box.getAttribute('data-bag-mm')) || 250) / 10;
      var mode = 'hand';
      // Figure units: 360 × 800, 800 = her height. Right hand (as you look) at (263, 444); hips at y ≈ 396.
      function layout() {
        var h = clamp(parseInt(range.value, 10) || 165, 140, 200);
        var imgW = (bagCm / h * 800) / 0.827;
        var cx = mode === 'hand' ? 263 : 246;
        var top = mode === 'hand' ? 430 - 0.032 * imgW : 392 - 0.308 * imgW;
        var left = cx - imgW / 2;
        bag.style.left = (left / 360 * 100) + '%';
        bag.style.top = (top / 800 * 100) + '%';
        bag.style.width = (imgW / 360 * 100) + '%';
        tag.style.left = (cx / 360 * 100) + '%';
        tag.style.top = ((top + 0.975 * imgW) / 800 * 100) + '%';
        var ly = top + 0.36 * imgW;
        front.setAttribute('x1', '150'); front.setAttribute('y1', '132');
        front.setAttribute('x2', String(left + 0.14 * imgW)); front.setAttribute('y2', String(ly));
        back.setAttribute('x1', String(left + 0.86 * imgW)); back.setAttribute('y1', String(ly));
        back.setAttribute('x2', '226'); back.setAttribute('y2', '170');
        you.setAttribute('data-mode', mode);
        var txt = T('height_out', '[cm] cm · [imperial]').replace('[cm]', h).replace('[imperial]', ftIn(h));
        setText(out, txt);
        setText(rule, T('height_cm', '[n] cm').replace('[n]', h));
        if (note) setText(note, (note.getAttribute('data-tpl') || '').replace('[h]', txt));
      }
      range.addEventListener('input', layout);
      range.addEventListener('change', function () { track('real_height', { cm: parseInt(range.value, 10) }); });
      $$('[data-jc-you-mode]', you).forEach(function (b) {
        b.addEventListener('click', function () {
          mode = b.getAttribute('data-jc-you-mode');
          $$('[data-jc-you-mode]', you).forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
          layout();
          track('real_carry', { mode: mode });
        });
      });
      layout();
    });
  }

  /* ---------- Gallery: dots, count, pinch-zoom ---------- */
  function initGallery(scope) {
    var gal = $('[data-jc-gal]', scope);
    if (!gal || gal.dataset.jcInit) return;
    gal.dataset.jcInit = '1';
    var track_ = $('[data-jc-gal-track]', gal);
    var slides = $$('[data-jc-slide]', gal);
    var thumbs = $$('[data-jc-thumb]', gal);
    var seen = {};
    function current(i) {
      thumbs.forEach(function (t, k) { var on = k === i; t.classList.toggle('is-on', on); if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      gal.classList.toggle('is-away', i !== 0);
      if (i > 0 && !seen[i]) { seen[i] = true; track('gallery_view', { slide: i + 1 }); }
    }
    if (track_ && 'IntersectionObserver' in window && getComputedStyle(track_).display === 'flex') {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting || e.intersectionRatio < 0.6) return;
          current(slides.indexOf(e.target));
        });
      }, { root: track_, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        if (!track_ || !slides[k]) return;
        track_.scrollTo({ left: k * track_.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
        current(k);
      });
    });
    // One gentle peek at slide 2, once per visit, so she knows there's more (phones only, never with reduced motion)
    var touchedGal = false;
    gal.addEventListener('pointerdown', function () { touchedGal = true; }, { once: true });
    if (!reduceMotion && slides.length > 1 && slides[0].animate) {
      var peeked = false;
      try { peeked = sessionStorage.getItem('jc-peek') === '1'; } catch (e) { /* private mode */ }
      if (!peeked) onVisible(gal, function () {
        setTimeout(function () {
          if (touchedGal || !track_ || track_.scrollLeft > 4 || getComputedStyle(track_).display !== 'flex') return;
          try { sessionStorage.setItem('jc-peek', '1'); } catch (e) { /* private mode */ }
          var kf = [{ transform: 'translateX(0)' }, { transform: 'translateX(-64px)', offset: 0.45 }, { transform: 'translateX(0)' }];
          [slides[0], slides[1]].forEach(function (s) { s.animate(kf, { duration: 1100, easing: 'cubic-bezier(.45,0,.2,1)' }); });
        }, 1400);
      }, 0.6);
    }
    // Two-finger pinch on a photo zooms it in place; it springs back on release.
    slides.forEach(function (s) {
      var img = $('.jc-gal__img, .jc-gal__cut', s);
      if (!img) return;
      var pts = {}, d0 = 0;
      function dist() { var p = Object.keys(pts).map(function (k) { return pts[k]; }); return p.length < 2 ? 0 : Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y); }
      s.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'touch') return; pts[e.pointerId] = { x: e.clientX, y: e.clientY }; if (Object.keys(pts).length === 2) { d0 = dist(); var r = s.getBoundingClientRect(); var p = Object.keys(pts).map(function (k) { return pts[k]; }); img.style.setProperty('--ox', ((p[0].x + p[1].x) / 2 - r.left) + 'px'); img.style.setProperty('--oy', ((p[0].y + p[1].y) / 2 - r.top) + 'px'); s.classList.add('is-zoom'); } });
      s.addEventListener('pointermove', function (e) { if (!pts[e.pointerId]) return; pts[e.pointerId] = { x: e.clientX, y: e.clientY }; if (d0) img.style.transform = 'scale(' + clamp(dist() / d0, 1, 3) + ')'; });
      function end(e) { delete pts[e.pointerId]; if (Object.keys(pts).length < 2 && d0) { d0 = 0; s.classList.remove('is-zoom'); img.style.transform = ''; } }
      s.addEventListener('pointerup', end); s.addEventListener('pointercancel', end);
      s.style.touchAction = 'pan-x pan-y';
    });
  }

  /* ---------- Delivery estimate (the bag) ---------- */
  function initEta(scope) {
    $$('[data-jc-eta]', scope).forEach(function (el) {
      if (el.dataset.jcInit) return;
      el.dataset.jcInit = '1';
      var country = (el.getAttribute('data-country') || '').toUpperCase();
      var windows = {};
      (el.getAttribute('data-windows') || '').split('|').forEach(function (line) {
        var m = line.trim().match(/^([A-Za-z*]{1,2})\s*:\s*(\d+)\s*[-–]\s*(\d+)$/);
        if (m) windows[m[1].toUpperCase()] = [parseInt(m[2], 10), parseInt(m[3], 10)];
      });
      var w = windows[country] || windows['*'];
      if (!w) return;
      var tz = el.getAttribute('data-tz') || '+0000';
      var sign = tz.charAt(0) === '-' ? -1 : 1;
      var offsetMin = sign * (parseInt(tz.substr(1, 2), 10) * 60 + parseInt(tz.substr(3, 2), 10));
      var n = new Date();
      var now = new Date(n.getTime() + (n.getTimezoneOffset() + offsetMin) * 60000);
      function addBusinessDays(d, days) { var r = new Date(d); while (days > 0) { r.setDate(r.getDate() + 1); var day = r.getDay(); if (day !== 0 && day !== 6) days--; } return r; }
      function fmt(d) { return d.toLocaleDateString(lang, { month: 'short', day: 'numeric' }); }
      var txt = $('[data-jc-eta-text]', el);
      if (txt) txt.innerHTML = 'Order today → arrives <strong>' + fmt(addBusinessDays(now, w[0])) + ' – ' + fmt(addBusinessDays(now, w[1])) + '</strong>';
      el.hidden = false;
    });
  }

  /* ---------- Announcement bar ---------- */
  function initAnn(scope) {
    var bar = $('[data-jc-ann]', scope);
    if (!bar || bar.dataset.jcInit) return;
    bar.dataset.jcInit = '1';
    var msgs = $$('.jc-ann__msg', bar);
    if (msgs.length < 2 || reduceMotion) return;
    var i = 0, timer = null;
    function show() { msgs.forEach(function (m, k) { m.classList.toggle('is-active', k === i); m.setAttribute('aria-hidden', k === i ? 'false' : 'true'); }); }
    function start() { stop(); bar.classList.add('is-rotating'); show(); timer = setInterval(function () { if (!bar.isConnected) { stop(); return; } i = (i + 1) % msgs.length; show(); }, 4000); }
    function stop() { if (timer) clearInterval(timer); timer = null; }
    bar.addEventListener('mouseenter', stop); bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop); bar.addEventListener('focusout', start);
    start();
  }

  /* ---------- Lineup: lift the selected bag 4px ---------- */
  function lineupSelect(stage, slug, animate) {
    var lift = $('[data-jc-lineup-lift]', stage);
    var bag = $('[data-jc-lineup-bag][data-jc-strip="' + slug + '"]', stage);
    if (!lift) return;
    if (!bag) { lift.classList.remove('is-set', 'is-up'); return; }
    var st = bag.style;
    lift.classList.remove('is-up');
    ['l', 'r', 't', 'b'].forEach(function (k) { lift.style.setProperty('--l' + k, st.getPropertyValue('--' + k)); });
    lift.classList.add('is-set');
    if (animate && !reduceMotion) void lift.offsetWidth;
    lift.classList.add('is-up');
  }

  /* ---------- Real size: pixels per millimetre for this screen ---------- */
  function estimatePpm() {
    var dpr = window.devicePixelRatio || 1;
    var coarse = window.matchMedia('(pointer: coarse)').matches;
    var shortSide = Math.min(screen.width, screen.height);
    if (coarse) return shortSide < 600 ? 6.1 : 5.2;
    if (dpr >= 2) return 5.0;
    if (dpr >= 1.25) return 4.35;
    return 3.78;
  }
  function initActual(scope) {
    $$('[data-jc-actual]', scope).forEach(function (sec) {
      if (sec.dataset.jcInit) return;
      sec.dataset.jcInit = '1';
      var base = estimatePpm();
      var saved = parseFloat(store('jc-ppm'));
      var ppm = saved && saved > 2 && saved < 12 ? saved : base;
      sec.style.setProperty('--ppm', ppm.toFixed(3));
      sec.style.setProperty('--bagmm', sec.getAttribute('data-bag-mm') || '250');
      var btn = $('[data-jc-calibrate]', sec), box = $('[data-jc-calib]', sec), range = $('[data-jc-calib-range]', sec);
      if (btn && box) btn.addEventListener('click', function () { box.hidden = !box.hidden; btn.setAttribute('aria-expanded', box.hidden ? 'false' : 'true'); });
      if (range) {
        range.value = String(Math.round((ppm / base) * 100));
        range.addEventListener('input', function () { ppm = base * parseInt(range.value, 10) / 100; sec.style.setProperty('--ppm', ppm.toFixed(3)); store('jc-ppm', ppm.toFixed(3)); });
      }
    });
  }

  /* ---------- Stories: the registry, the fold bubble and the viewer ---------- */
  var stories = [];
  function collectStories() {
    stories = [];
    $$('[data-jc-stories]').forEach(function (s) { try { stories = stories.concat(JSON.parse(s.textContent) || []); } catch (e) { /* skip */ } });
    return stories;
  }
  function initBubble(scope) {
    var bubble = $('[data-jc-bubble]', scope);
    if (!bubble || bubble.dataset.jcInit) return;
    bubble.dataset.jcInit = '1';
    collectStories();
    var btn = bubble.closest('.jc-bubble-open');
    if (!stories.length) { if (btn) btn.hidden = true; return; }
    if (bubble.querySelector('video, img')) return;
    var s = stories[0];
    if (s.video && !reduceMotion) bubble.innerHTML = '<video class="jc-bubble-open__vid" src="' + s.video + '" muted playsinline loop autoplay preload="metadata"' + (s.poster ? ' poster="' + s.poster + '"' : '') + '></video>';
    else if (s.poster) bubble.innerHTML = '<img class="jc-bubble-open__vid" src="' + s.poster + '" alt="">';
  }

  var viewer = null;
  /* Instagram-style viewer. A story = { slides: [{video, poster}, …], cover, name, colour, quote, review, hold, add, … }
     (an older one-clip story counts as one slide; an empty slide {} is a stand-in: the bag in the story's colour).
     Tap right/left: next/previous slide, then the next/previous story. Hold: pause (the tap after a hold doesn't skip).
     Swipe sideways: next/previous story. Her words show as a small story comment. Keys: ←/→, Esc.
     Like Instagram: photos load ahead (the rest of this story, the next story's first) at the size the frame needs, so
     the next one shows at once, and a photo's time only runs once it is on screen. Dragging down, the story follows the
     finger, shrinks and lets the page show through; let go far enough (or flick) and it shrinks back into the ring or
     card it came from, else it springs back. Opening grows out of that ring/card; ✕ and Esc close the same way.
     Story to story (one person to the next) turns like Instagram's cube: swiping sideways turns it under the finger
     (past a third, or a flick, it goes on; else it turns back), and a story that ends, or a tap past its last slide,
     turns it by itself. Slides within one story just change. Reduced motion: no turning, no growing. */
  function initViewer() {
    var dlg = $('[data-jc-stories-viewer]');
    if (!dlg || dlg.dataset.jcInit) return;
    dlg.dataset.jcInit = '1';
    var bars = $('[data-jc-st-bars]', dlg), media = $('[data-jc-st-media]', dlg), who = $('[data-jc-st-who]', dlg);
    var sub = $('[data-jc-st-sub]', dlg), av = $('[data-jc-st-av]', dlg);
    var chip = $('[data-jc-st-chip]', dlg), addB = $('[data-jc-st-add]', dlg), addL = $('[data-jc-st-add-label]', dlg);
    var cmt = $('[data-jc-st-cmt]', dlg), cmtT = 0, muteB = $('[data-jc-st-mute]', dlg), frame = $('.jc-stories__frame', dlg);
    var gi = 0, sj = 0, muted = true, paused = false, t0 = 0, raf = null, vid = null, pre = null, elapsed = 0, held = false, pressT = 0;
    var waiting = false, token = 0, cache = {}, opener = null, closing = false;
    var tpl = ($('[data-jc-buy-data]') && JSON.parse($('[data-jc-buy-data]').textContent).storyAddLabel) || 'Add [colour] to bag';
    function group(k) { var s = stories[k]; if (!s) return null; if (!s.slides || !s.slides.length) s.slides = [{ video: s.video || '', poster: s.poster || '' }]; return s; }
    function dur() { var g = group(gi); return (g && g.hold) || 5000; }

    /* Photos ahead of time, at the width the frame needs (worked out without reading layout, so a photo warmed before
       the viewer opens is the very same file it then shows) */
    function photoW() {
      var vw = window.innerWidth, vh = window.innerHeight;
      var fw = vw >= 1024 ? (vh - 48) * 9 / 16 : Math.min(vw, vh * 9 / 16);
      var need = fw * (window.devicePixelRatio || 1);
      return need <= 560 ? 540 : (need <= 760 ? 720 : 1080);
    }
    function warmImg(u) {
      if (!u) return null;
      var url = sized(u, photoW()), im = cache[url];
      if (!im) {
        im = new Image();
        im.decoding = 'async';
        im.alt = '';
        im.src = url;
        cache[url] = im;
        if (im.decode) im.decode().catch(function () {});
      }
      return im;
    }
    function ready(im) { return !!im && im.complete && im.naturalWidth > 0; }
    function warmStory(k, from, n) {
      if (!stories.length) return;
      var g = group(((k % stories.length) + stories.length) % stories.length);
      if (!g) return;
      g.slides.slice(from || 0, (from || 0) + (n || g.slides.length)).forEach(function (s) { if (s.poster && !s.video) warmImg(s.poster); });
    }
    /* The same photo already on the page (its card in the section, at the card's size): shown at once while the full
       one arrives */
    function onPage(u) {
      var path = u.split('?')[0].replace(/^https?:/, ''), hit = null;
      Array.prototype.some.call(document.images, function (i) {
        var src = i.currentSrc || i.src || '';
        if (i.complete && i.naturalWidth && src.split('?')[0].replace(/^https?:/, '') === path && !dlg.contains(i)) { hit = src; return true; }
        return false;
      });
      return hit;
    }

    function bar(p) { var s = bars.children[sj]; if (s) s.firstChild.style.setProperty('--p', String(clamp(p, 0, 1))); }
    function stop() { cancelAnimationFrame(raf); raf = null; if (vid) { vid.pause(); } }
    function tick(ts) {
      if (!t0) t0 = ts;
      if (!paused && !waiting) {
        if (vid && vid.duration) bar(vid.currentTime / vid.duration);
        else if (!vid) { elapsed += ts - t0; bar(elapsed / dur()); if (elapsed >= dur()) { next(); return; } }
      }
      t0 = ts;
      raf = requestAnimationFrame(tick);
    }
    /* A story's name, avatar, colour chip and add button, into a frame (the live one, or the cube's other face) */
    function paint(r, g, c) {
      var clean = document.body.classList.contains('jc-clean');
      setText(r.who, g.name || (c ? c.name : ''));
      setText(r.sub, [c && g.name && g.name !== c.name ? c.name : '', g.verified ? T('verified_buyer', 'Verified buyer') : '', g.demo && !clean ? 'Demo' : ''].filter(Boolean).join(' · '));
      r.av.style.setProperty('--c', c ? c.hex : '#ddd');
      r.av.innerHTML = g.cover ? '<img src="' + g.cover + '" alt="">' : ((c && c.face) ? '<img class="jc-stories__face" src="' + c.face + '" alt="">' : '');
      r.av.classList.toggle('is-photo', !!g.cover);
      r.chip.style.setProperty('--c', c ? c.hex : '#ddd');
      setText($('span', r.chip), c ? c.name : '');
      r.chip.hidden = !c;
      setText(r.addL, tpl.replace('[colour]', c ? c.name : ''));
      r.addB.dataset.slug = g.colour || '';
      r.addB.hidden = g.add === false || !buy || !c;
    }
    var live = { who: who, sub: sub, av: av, chip: chip, addL: addL, addB: addB };
    /* No photo yet: the bag in her colour (draft), or the placeholder card */
    function standIn(g, j, c) {
      if (document.body.classList.contains('jc-clean')) return '<span class="jc-slot jc-slot--clean jc-stories__stand jc-stories__stand--v' + ((j % 3) + 1) + '" style="background: color-mix(in srgb, ' + (c ? c.hex : '#ddd') + ' 30%, #fff);" aria-hidden="true"><span class="jc-slot__bag"><img src="' + ((c && (c.cutout || c.face)) || '') + '" alt=""></span></span>';
      return '<span class="jc-slot" role="img" aria-label="Placeholder"><span class="jc-slot__tag">Placeholder · 9:16</span><span class="jc-slot__label">' + (g.moment || 'Customer story') + ' · ' + (j + 1) + '/' + g.slides.length + '</span><span class="jc-slot__spec">Her own photo or clip, with permission</span></span>';
    }
    function head(g, c) {
      paint(live, g, c);
      // Her words as a small comment on the story (Instagram's story comments): her face, her name, what she wrote.
      // It fades in just after the story starts, so she's seen first. No swipe-up sheet.
      var said = g.review || g.quote || '';
      clearTimeout(cmtT);
      cmt.classList.remove('is-in');
      cmt.hidden = !said;
      if (said) {
        $('[data-jc-st-cmt-av]', cmt).innerHTML = av.innerHTML;
        $('[data-jc-st-cmt-av]', cmt).className = 'jc-stories__cmt-av' + (g.cover ? ' is-photo' : '');
        $('[data-jc-st-cmt-av]', cmt).style.setProperty('--c', c ? c.hex : '#ddd');
        setText($('[data-jc-st-cmt-who]', cmt), g.name || (c ? c.name : ''));
        setText($('[data-jc-st-cmt-text]', cmt), said);
        cmtT = setTimeout(function () { cmt.classList.add('is-in'); }, reduceMotion ? 0 : 900);
      }
    }
    function render(k, j) {
      stop();
      var fresh = k !== gi || !bars.children.length;
      gi = (k + stories.length) % stories.length;
      var g = group(gi);
      sj = clamp(j || 0, 0, g.slides.length - 1);
      var c = buy ? buy.colour(g.colour) : null;
      if (fresh) head(g, c);
      bars.innerHTML = g.slides.map(function (_, n) { return '<span><i style="--p:' + (n < sj ? 1 : 0) + '"></i></span>'; }).join('');
      var s = g.slides[sj] || {};
      vid = null; elapsed = 0; t0 = 0; waiting = false; token++;
      media.classList.remove('is-wait');
      if (s.video) {
        // the clip warmed up while the last slide played, when it's this one; else a fresh one
        var v = pre && pre.getAttribute('src') === s.video ? pre : null;
        if (v) pre = null;
        else { v = document.createElement('video'); v.preload = 'auto'; v.src = s.video; }
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.muted = muted;
        if (s.poster) v.poster = s.poster;
        media.replaceChildren(v);
        vid = v;
        vid.addEventListener('ended', next);
        vid.addEventListener('error', function () { if (vid === v) vid = null; });
        if (!paused) vid.play().catch(function () {});
      } else if (s.poster) {
        var im = warmImg(s.poster);
        if (ready(im)) media.replaceChildren(im);
        else {
          var near = onPage(s.poster), tk = token;
          if (near) { var ph = new Image(); ph.alt = ''; ph.src = near; media.replaceChildren(ph); }   // the card's copy now, the sharp one in a moment
          else { waiting = true; media.classList.add('is-wait'); }                                     // the last photo stays until this one is in
          var shown = function () {
            if (tk !== token) return;
            media.replaceChildren(im);
            if (waiting) { waiting = false; media.classList.remove('is-wait'); elapsed = 0; t0 = 0; }
          };
          im.addEventListener('load', shown, { once: true });
          im.addEventListener('error', shown, { once: true });
        }
      } else {
        // No photo yet (draft only): the bag in her colour on its tint, framed a little differently on each slide
        media.innerHTML = standIn(g, sj, c);
      }
      // warm up what comes next: the rest of this story's photos, and from its last two slides the next story's first
      warmStory(gi, sj + 1, 3);
      if (sj >= g.slides.length - 2) warmStory(gi + 1, 0, 2);
      var ng = group((gi + 1) % stories.length), nx = g.slides[sj + 1] || (ng && ng.slides[0]);
      if (nx && nx.video && (!pre || pre.getAttribute('src') !== nx.video)) { pre = document.createElement('video'); pre.preload = 'auto'; pre.muted = true; pre.src = nx.video; }
      raf = requestAnimationFrame(tick);
    }
    /* The cube's other face: a still copy of the frame showing story k's first slide (its photo is warm by now) */
    function face(k) {
      var g = group(k), c = buy ? buy.colour(g.colour) : null, s = g.slides[0] || {};
      var f = frame.cloneNode(true);
      var q = function (sel) { return f.querySelector(sel); };
      paint({ who: q('[data-jc-st-who]'), sub: q('[data-jc-st-sub]'), av: q('[data-jc-st-av]'), chip: q('[data-jc-st-chip]'), addL: q('[data-jc-st-add-label]'), addB: q('[data-jc-st-add]') }, g, c);
      q('[data-jc-st-bars]').innerHTML = g.slides.map(function () { return '<span><i style="--p:0"></i></span>'; }).join('');
      var cm = q('[data-jc-st-cmt]');
      if (cm) cm.hidden = true;
      var m = q('[data-jc-st-media]');
      m.classList.remove('is-wait');
      if (s.poster && !s.video) {
        var im = warmImg(s.poster), src = ready(im) ? im.src : onPage(s.poster);
        m.replaceChildren();
        if (src) { var ph = new Image(); ph.alt = ''; ph.src = src; m.append(ph); }
      } else if (s.poster) { var pv = new Image(); pv.alt = ''; pv.src = s.poster; m.replaceChildren(pv); }
      else m.innerHTML = standIn(g, 0, c);
      // a still picture: no ids, no hooks, nothing to tap
      Array.prototype.forEach.call(f.querySelectorAll('*'), function (el) {
        Array.prototype.slice.call(el.attributes).forEach(function (a) { if (a.name.indexOf('data-jc-') === 0) el.removeAttribute(a.name); });
      });
      f.removeAttribute('style');
      f.classList.add('jc-stories__frame--face');
      f.setAttribute('aria-hidden', 'true');
      f.inert = true;
      f.style.left = frame.offsetLeft + 'px'; f.style.top = frame.offsetTop + 'px';
      f.style.width = frame.offsetWidth + 'px'; f.style.height = frame.offsetHeight + 'px';
      return f;
    }
    var cube = null;   // { f: the other face, k: the story it shows (null: nothing that way), dir: 1 on / -1 back, p: 0…1 }
    /* Two faces of a cube meeting at one edge: this story turns away from it, the other turns in */
    function cubeAt(p) {
      var W = frame.offsetWidth || window.innerWidth, d = cube.dir, f = cube.f;
      cube.p = p;
      frame.style.transformOrigin = d > 0 ? '100% 50%' : '0% 50%';
      frame.style.transform = 'translateX(' + (-d * p * W).toFixed(1) + 'px) rotateY(' + (-d * p * 90).toFixed(2) + 'deg)';
      frame.style.setProperty('--shade', (p * 0.6).toFixed(3));
      if (f) {
        f.style.transformOrigin = d > 0 ? '0% 50%' : '100% 50%';
        f.style.transform = 'translateX(' + (d * (1 - p) * W).toFixed(1) + 'px) rotateY(' + (d * (1 - p) * 90).toFixed(2) + 'deg)';
        f.style.setProperty('--shade', ((1 - p) * 0.6).toFixed(3));
      }
    }
    function cubeStart(k, dir) {
      stop();
      cube = { f: k === null ? null : face(k), k: k, dir: dir, p: 0 };
      if (cube.f) dlg.insertBefore(cube.f, frame.nextSibling);
      dlg.classList.add('is-cube');
    }
    function cubeEnd(go) {
      var c = cube;
      cube = null;
      if (c.f) c.f.remove();
      frame.style.transform = ''; frame.style.transformOrigin = ''; frame.style.removeProperty('--shade');
      dlg.classList.remove('is-cube');
      if (go && c.k !== null) { render(c.k, 0); return; }
      // turned back: the same story carries on where it was
      t0 = 0;
      if (vid && !paused) vid.play().catch(function () {});
      raf = requestAnimationFrame(tick);
    }
    function cubeRun(to, ms, then) {
      var from = cube.p, start = 0;
      function step(ts) {
        if (!cube) return;
        if (!start) start = ts;
        var x = Math.min(1, (ts - start) / ms), e = x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
        cubeAt(from + (to - from) * e);
        if (x < 1) requestAnimationFrame(step); else then();
      }
      requestAnimationFrame(step);
    }
    function turnTo(k, dir) {
      if (cube) return;
      if (reduceMotion || !frame.animate) { render(k, 0); return; }
      cubeStart(k, dir);
      cubeRun(1, 440, function () { cubeEnd(true); });
    }
    function next() {
      if (cube) return;
      var g = group(gi);
      if (sj < g.slides.length - 1) { render(gi, sj + 1); return; }
      if (gi >= stories.length - 1) { close(); return; }
      turnTo(gi + 1, 1);
    }
    function prev() {
      if (cube) return;
      if (sj > 0) { render(gi, sj - 1); return; }
      if (gi > 0) turnTo(gi - 1, -1); else render(0, 0);
    }
    function nextStory() { if (cube) return; if (gi >= stories.length - 1) { close(); return; } turnTo(gi + 1, 1); }
    function prevStory() { if (cube) return; if (gi > 0) turnTo(gi - 1, -1); else render(0, 0); }
    /* Where the story came from, if it's on screen: its ring, its card in the section, or the fold's bubble */
    function originEl() {
      var el = null;
      if (opener === 'ring') el = $('.jc-mo__rbtn[data-jc-story-open="' + gi + '"] .jc-mo__ring');
      else if (opener === 'card') { var o = $('.jc-mo__open[data-jc-story-open="' + gi + '"]'); el = o && (o.closest('.jc-mo__media') || o); }
      else if (opener === 'bubble' && gi === 0) el = $('.jc-bubble-open');
      if (!el) return null;
      var r = el.getBoundingClientRect();
      if (!r.width || r.bottom < 0 || r.top > window.innerHeight || r.right < 0 || r.left > window.innerWidth) return null;
      return { r: r, round: opener !== 'card' };
    }
    function radius() { return window.innerWidth >= 1024 ? 12 : 0; }
    function rest() { return { transform: 'translate3d(0px, 0px, 0px) scale(1)', clipPath: 'inset(0px 0px 0px 0px round ' + radius() + 'px)', opacity: 1 }; }
    /* The frame laid over the origin: moved and scaled to its width, cropped to its shape (a circle for a ring) */
    function atOrigin(o) {
      var d = dlg.getBoundingClientRect(), b = { left: d.left + frame.offsetLeft, top: d.top + frame.offsetTop, width: frame.offsetWidth, height: frame.offsetHeight };
      var k = o.r.width / b.width;
      var tx = o.r.left + o.r.width / 2 - (b.left + b.width / 2), ty = o.r.top + o.r.height / 2 - (b.top + b.height / 2);
      var ih = Math.max(0, (b.height - o.r.height / k) / 2);
      var rad = o.round ? b.width / 2 : 16 / k;
      return { transform: 'translate3d(' + tx.toFixed(1) + 'px, ' + ty.toFixed(1) + 'px, 0px) scale(' + k.toFixed(4) + ')', clipPath: 'inset(' + ih.toFixed(1) + 'px 0px ' + ih.toFixed(1) + 'px 0px round ' + rad.toFixed(1) + 'px)', opacity: 1 };
    }
    var EASE = 'cubic-bezier(0.32, 0.72, 0, 1)';
    function finish() {
      closing = false;
      if (cube) { if (cube.f) cube.f.remove(); cube = null; dlg.classList.remove('is-cube'); frame.style.transformOrigin = ''; frame.style.removeProperty('--shade'); }
      if (frame.getAnimations) frame.getAnimations().forEach(function (a) { a.cancel(); });
      if (dlg.getAnimations) dlg.getAnimations().forEach(function (a) { a.cancel(); });
      frame.style.transform = ''; frame.style.clipPath = ''; dlg.style.backgroundColor = '';
      dlg.classList.remove('is-moving');
      if (dlg.open) dlg.close();
    }
    function close() {
      stop(); clearTimeout(cmtT);
      if (closing || !dlg.open) return;
      if (reduceMotion || !frame.animate) { finish(); return; }
      closing = true;
      dlg.classList.add('is-moving');
      var o = originEl();
      var from = { transform: frame.style.transform || rest().transform, clipPath: frame.style.clipPath || rest().clipPath, opacity: 1 };
      var frames;
      if (o) { var to = atOrigin(o); frames = [from, { transform: to.transform, clipPath: to.clipPath, opacity: 1, offset: 0.78 }, { transform: to.transform, clipPath: to.clipPath, opacity: 0 }]; }
      else frames = [from, { transform: 'translate3d(0px, ' + Math.round(window.innerHeight * 0.5) + 'px, 0px) scale(0.6)', clipPath: 'inset(0px 0px 0px 0px round 28px)', opacity: 0 }];
      var a = frame.animate(frames, { duration: o ? 320 : 260, easing: EASE, fill: 'forwards' });
      dlg.animate([{ backgroundColor: dlg.style.backgroundColor || 'rgb(0, 0, 0)' }, { backgroundColor: 'rgba(0, 0, 0, 0)' }], { duration: 260, easing: 'ease-out', fill: 'forwards' });
      a.onfinish = finish;
      a.oncancel = finish;
    }
    /* Opening grows out of the ring / card she tapped */
    function grow() {
      if (reduceMotion || !frame.animate) return;
      var o = originEl();
      var from = o ? atOrigin(o) : { transform: 'translate3d(0px, 32px, 0px) scale(0.94)', clipPath: 'inset(0px 0px 0px 0px round 16px)', opacity: 0 };
      dlg.classList.add('is-moving');
      var a = frame.animate([from, rest()], { duration: o ? 340 : 240, easing: EASE });
      dlg.animate([{ backgroundColor: 'rgba(0, 0, 0, 0)' }, { backgroundColor: 'rgb(0, 0, 0)' }], { duration: 260, easing: 'ease-out' });
      a.onfinish = function () { dlg.classList.remove('is-moving'); };
    }
    $('[data-jc-st-next]', dlg).addEventListener('click', function () { if (held) { held = false; return; } next(); });
    $('[data-jc-st-prev]', dlg).addEventListener('click', function () { if (held) { held = false; return; } prev(); });
    $('[data-jc-st-gnext]', dlg).addEventListener('click', nextStory);
    $('[data-jc-st-gprev]', dlg).addEventListener('click', prevStory);
    $('[data-jc-st-close]', dlg).addEventListener('click', close);
    dlg.addEventListener('close', stop);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });   // Esc: the same way out
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });
    // A click on the dark space beside the frame (desktop) closes, like Instagram
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    muteB.addEventListener('click', function () {
      muted = !muted;
      if (vid) vid.muted = muted;
      muteB.setAttribute('aria-pressed', String(!muted));
      muteB.setAttribute('aria-label', muted ? T('unmute', 'Unmute') : T('mute', 'Mute'));
    });
    var y0 = null, x0 = null, dragging = false, lastY = 0, lastT = 0, vy = 0, hdrag = false, lastX = 0, lastTx = 0, vx = 0;
    /* Dragging down: the story follows the finger, shrinks a little, rounds its corners, and the page shows through */
    function dragTo(d) {
      var p = Math.min(1, Math.max(0, d / (window.innerHeight || 800)));
      frame.style.transform = 'translate3d(0px, ' + Math.max(0, d).toFixed(1) + 'px, 0px) scale(' + (1 - p * 0.4).toFixed(4) + ')';
      frame.style.clipPath = 'inset(0px 0px 0px 0px round ' + Math.round(Math.min(28, radius() + p * 90)) + 'px)';
      dlg.style.backgroundColor = 'rgba(0, 0, 0, ' + (1 - Math.min(1, p * 2.4) * 0.9).toFixed(3) + ')';
    }
    frame.addEventListener('pointerdown', function (e) {
      if (closing || cube) return;
      if (e.target.closest('button') && !e.target.closest('.jc-stories__zone')) return;
      paused = true; held = false; pressT = performance.now();
      if (vid) vid.pause();
      y0 = e.clientY; x0 = e.clientX; lastY = e.clientY; lastT = e.timeStamp; vy = 0; dragging = false;
      hdrag = false; lastX = e.clientX; lastTx = e.timeStamp; vx = 0;
    });
    frame.addEventListener('pointermove', function (e) {
      if (y0 === null) return;
      var dy = e.clientY - y0, dx = e.clientX - x0;
      // sideways: the cube turns under the finger, towards the next story (left) or the one before (right)
      if (!dragging && !hdrag && !reduceMotion && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        hdrag = true; held = true;
        var dir = dx < 0 ? 1 : -1, k = gi + dir;
        cubeStart(k >= 0 && k < stories.length ? k : null, dir);
        try { frame.setPointerCapture(e.pointerId); } catch (err) { /* older browsers */ }
      }
      if (hdrag) {
        if (!cube) return;
        var W = frame.offsetWidth || window.innerWidth, pp = Math.max(0, -cube.dir * dx / W);
        if (cube.k === null) pp = Math.min(0.12, pp * 0.25);   // nothing that way: it gives only a little
        var dtx = e.timeStamp - lastTx;
        if (dtx > 0) vx = (e.clientX - lastX) / dtx;
        lastX = e.clientX; lastTx = e.timeStamp;
        cubeAt(Math.min(1, pp));
        return;
      }
      if (!dragging && dy > 10 && dy > Math.abs(dx)) {
        dragging = true; held = true;
        dlg.classList.add('is-moving');
        try { frame.setPointerCapture(e.pointerId); } catch (err) { /* older browsers: plain moves still arrive */ }
      }
      if (!dragging) return;
      var dt = e.timeStamp - lastT;
      if (dt > 0) vy = (e.clientY - lastY) / dt;
      lastY = e.clientY; lastT = e.timeStamp;
      dragTo(dy);
    });
    function release(e, cancelled) {
      if (y0 === null) return;
      var dy = e.clientY - y0, dx = e.clientX - x0;
      y0 = null; paused = false;
      if (hdrag) {
        hdrag = false;
        if (!cube) return;
        var flick = cube.dir > 0 ? vx < -0.45 : vx > 0.45;
        var go = cube.k !== null && !cancelled && (cube.p > 0.3 || flick);
        // past the last story, a swipe on: out, like Instagram
        if (cube.k === null && cube.dir > 0 && !cancelled && (dx < -60 || flick)) { cubeEnd(false); close(); return; }
        cubeRun(go ? 1 : 0, go ? Math.max(180, 420 * (1 - cube.p)) : 260, function () { cubeEnd(go); });
        return;
      }
      if (dragging) {
        dragging = false;
        // far enough, or a flick: shrink back to where it came from
        if (!cancelled && (dy > window.innerHeight * 0.16 || vy > 0.55)) { close(); return; }
        // not far enough: back into place, and the story carries on
        var from = { transform: frame.style.transform, clipPath: frame.style.clipPath }, bg = dlg.style.backgroundColor;
        frame.style.transform = ''; frame.style.clipPath = ''; dlg.style.backgroundColor = '';
        if (frame.animate && !reduceMotion) {
          frame.animate([from, rest()], { duration: 240, easing: EASE });
          if (bg) dlg.animate([{ backgroundColor: bg }, { backgroundColor: 'rgb(0, 0, 0)' }], { duration: 240, easing: 'ease-out' });
        }
        dlg.classList.remove('is-moving');
        if (vid) vid.play().catch(function () {});
        return;
      }
      held = performance.now() - pressT > 260 && Math.abs(dx) < 12 && Math.abs(dy) < 12;
      if (vid) vid.play().catch(function () {});
      if (cancelled) return;
      // (reduced motion has no turning cube: a plain swipe still changes story)
      if (Math.abs(dx) > 60 && Math.abs(dy) < 60) { held = true; if (dx < 0) nextStory(); else prevStory(); }
    }
    frame.addEventListener('pointerup', function (e) { release(e, false); });
    frame.addEventListener('pointercancel', function (e) { release(e, true); });
    addB.addEventListener('click', function () {
      if (!buy || !addB.dataset.slug) return;
      addB.classList.add('is-loading');
      buy.addColour(addB.dataset.slug, addB, false).then(function (c) { toast(T('added_toast', '[colour] added to your bag ✓').replace('[colour]', c ? c.name : ''), dlg); })
        .catch(function (err) { toast(err.message, dlg); })
        .finally(function () { addB.classList.remove('is-loading'); });
    });
    viewer = {
      open: function (k, from) {
        collectStories();
        if (!stories.length) return;
        k = k || 0;
        opener = from || null;
        if (closing) finish();
        frame.style.transform = ''; frame.style.clipPath = ''; dlg.style.backgroundColor = '';
        media.replaceChildren();
        warmStory(k, 0, 4); warmStory(k + 1, 0, 1);
        if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        bars.innerHTML = ''; gi = -1;
        render(k, 0);
        grow();
      },
      // a finger on a ring or card: its first photos start loading before the tap is even over
      warm: function (k) { collectStories(); warmStory(k, 0, 2); }
    };
  }

  /* ---------- 3.1 The moment: one video plays at a time; tap to unmute ---------- */


  /* ---------- Drag to scroll (mouse) ---------- */
  function initDrag(scope) {
    $$('[data-jc-drag]', scope).forEach(function (el) {
      if (el.dataset.jcDrag) return;
      el.dataset.jcDrag = '1';
      var x0 = 0, s0 = 0, down = false, moved = false;
      el.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; x0 = e.clientX; s0 = el.scrollLeft; });
      window.addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; if (Math.abs(dx) > 4) { moved = true; el.classList.add('is-dragging'); el.scrollLeft = s0 - dx; } });
      window.addEventListener('pointerup', function () { if (!down) return; down = false; setTimeout(function () { el.classList.remove('is-dragging'); }, 0); });
      el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    });
  }

  /* ---------- 3.3 A day with him: the line follows the rail ---------- */
  function initDay(scope) {
    $$('[data-jc-day]', scope).forEach(function (sec) {
      if (sec.dataset.jcInit) return;
      sec.dataset.jcInit = '1';
      var rail = $('[data-jc-day-rail]', sec);
      if (!rail) return;
      rail.addEventListener('scroll', function () {
        var max = rail.scrollWidth - rail.clientWidth;
        sec.style.setProperty('--p', max > 0 ? (rail.scrollLeft / max).toFixed(3) : '0');
      }, { passive: true });
    });
  }

  /* ---------- 3.9 FAQ deep links ---------- */
  function openHash() {
    var id = decodeURIComponent((location.hash || '').slice(1));
    if (!id) return;
    var el = document.getElementById(id);
    if (el && el.tagName === 'DETAILS') { el.open = true; el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
  }

  /* ---------- Footer: save the colour ---------- */
  function initSave(scope) {
    $$('[data-jc-save]', scope).forEach(function (form) {
      if (form.dataset.jcInit) return;
      form.dataset.jcInit = '1';
      form.addEventListener('submit', function () {
        var email = ($('input[type="email"]', form) || {}).value;
        var name = ($('[data-jc-colour-name]', form) || {}).textContent;
        if (email && window.klaviyo && typeof window.klaviyo.push === 'function') { try { window.klaviyo.push(['identify', { $email: email, jelkin_saved_colour: name }]); } catch (e) { /* optional */ } }
      });
    });
  }

  /* ---------- The bag: siblings, conversions, the new line after each re-render ---------- */
  var newLine = null;
  function initDrawer() {
    var d = cartDrawer();
    if (!d || d.dataset.jcObs) return;
    d.dataset.jcObs = '1';
    function refresh() {
      fillUsd(d);
      var ex = d.querySelector('[data-jc-express]');
      if (ex && !ex.dataset.jcInit) {
        ex.dataset.jcInit = '1';
        try { if (window.Shopify && window.Shopify.StorefrontExpressButtons) window.Shopify.StorefrontExpressButtons.initialize(); } catch (e) { /* optional */ }
      }
      initEta(d);
      if (newLine) {
        var line = d.querySelector('[data-jc-line-variant="' + newLine + '"]');
        if (line && !reduceMotion) line.classList.add('is-new');
        if (line) newLine = null;
      }
      // The set price just kicked in (or grew): the bar and the discount row pop once
      var meter = d.querySelector('[data-jc-meter]');
      var off = meter ? parseInt(meter.getAttribute('data-jc-discount'), 10) || 0 : 0;
      if (lastOff !== null && off > lastOff && !reduceMotion) {
        [meter, d.querySelector('[data-jc-save-row]')].forEach(function (el) { if (el) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); } });
        buzz();
      }
      if (meter || !d.querySelector('.jc-line')) lastOff = off;
    }
    var lastOff = null;
    refresh();
    if ('MutationObserver' in window) new MutationObserver(function () { refresh(); }).observe(d, { childList: true, subtree: true });
    // Phones: pull the sheet down by its top to close it
    var y0 = null, dy = 0, panel = null;
    d.addEventListener('touchstart', function (e) {
      if (window.innerWidth >= 750 || !e.target.closest('.jc-bag__head')) return;
      panel = d.querySelector('.drawer__inner');
      y0 = e.touches[0].clientY; dy = 0;
      if (panel) panel.style.transition = 'none';
    }, { passive: true });
    d.addEventListener('touchmove', function (e) {
      if (y0 === null || !panel) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panel.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    d.addEventListener('touchcancel', function () {
      if (panel) { panel.style.transition = ''; panel.style.transform = ''; }
      y0 = null; panel = null;
    }, { passive: true });
    d.addEventListener('touchend', function () {
      if (y0 === null || !panel) return;
      panel.style.transition = '';
      panel.style.transform = '';
      if (dy > 90 && typeof d.close === 'function') { track('drawer_swipe_close'); d.close(); }
      y0 = null; panel = null;
    });
  }

  function scrollToBuy() {
    var b = buy && buy.atc;
    if (!b) return false;
    b.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    setTimeout(function () { b.classList.remove('jc-pulse'); void b.offsetWidth; b.classList.add('jc-pulse'); }, reduceMotion ? 0 : 550);
    return true;
  }

  /* ---------- Document-level delegation ---------- */
  document.addEventListener('click', function (e) {
    var tr = e.target.closest('[data-track]');
    if (tr && tr.tagName !== 'SELECT' && !(tr.tagName === 'INPUT' && (tr.type === 'range' || tr.type === 'radio'))) {
      var n = tr.getAttribute('data-track');
      if (['atc', 'sticky_atc', 'colour_select', 'bundle_select', 'inline_add'].indexOf(n) === -1) track(n);
    }

    var link = e.target.closest('[data-jc-scroll]');
    if (link) {
      var id = (link.getAttribute('href') || '').replace(/^.*#/, '');
      var target = id && document.getElementById(id);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); return; }
    }
    if (e.target.closest('[data-jc-to-buy]')) { if (scrollToBuy()) { e.preventDefault(); return; } }

    var pick = e.target.closest('[data-jc-pick]');
    if (pick && buy) {
      e.preventDefault();
      if (buy.pick(pick.getAttribute('data-jc-pick'))) track('colour_select', { colour: pick.getAttribute('data-jc-pick') });
      if (pick.hasAttribute('data-jc-close-after')) { var dl = pick.closest('dialog'); if (dl) setTimeout(function () { dl.close(); }, reduceMotion ? 0 : 550); }
      return;
    }

    var proxy = e.target.closest('[data-jc-tier-proxy]');
    if (proxy && buy) { buy.setTier(parseInt(proxy.getAttribute('data-jc-tier-proxy'), 10)); return; }
    var mslot = e.target.closest('[data-jc-mslot]');
    if (mslot && buy) { e.preventDefault(); buy.openSheet(parseInt(mslot.getAttribute('data-jc-mslot'), 10), mslot); return; }
    if (e.target.closest('[data-jc-mslot-more]') && buy) { e.preventDefault(); buy.more(); return; }
    var mrm = e.target.closest('[data-jc-mslot-remove]');
    if (mrm && buy) { e.preventDefault(); buy.remove(parseInt(mrm.getAttribute('data-jc-mslot-remove'), 10)); return; }

    var addSel = e.target.closest('[data-jc-add-selected]');
    if (addSel && buy) {
      e.preventDefault();
      addSel.classList.add('is-loading');
      buy.submit(addSel, addSel.hasAttribute('data-jc-final-cta') ? 'atc' : 'inline_add').finally(function () { addSel.classList.remove('is-loading'); });
      return;
    }
    /* Anywhere on the site (home, collection, about…), no fold needed: [data-jc-add-variant="<variant id>"] adds that
       bag, or [data-jc-add-lines='[{"id":…,"quantity":1},…]'] adds a set, then opens the bag. Optional
       data-jc-add-face="<image url>" flies that picture to the bag icon. */
    var addVar = e.target.closest('[data-jc-add-variant], [data-jc-add-lines]');
    if (addVar) {
      e.preventDefault();
      if (addVar.classList.contains('is-loading')) return;
      var lines;
      try {
        lines = addVar.hasAttribute('data-jc-add-lines') ? JSON.parse(addVar.getAttribute('data-jc-add-lines'))
          : [{ id: parseInt(addVar.getAttribute('data-jc-add-variant'), 10), quantity: parseInt(addVar.getAttribute('data-jc-add-qty') || '1', 10) }];
      } catch (x) { lines = []; }
      lines = (lines || []).filter(function (l) { return l && l.id && l.quantity > 0; });
      if (!lines.length) return;
      addVar.classList.add('is-loading');
      track('page_add', { bags: lines.reduce(function (n, l) { return n + l.quantity; }, 0) });
      addLines(lines, addVar, true)
        .then(function () {
          buzz();
          flyToCart(addVar, addVar.getAttribute('data-jc-add-face'));
          document.dispatchEvent(new CustomEvent('jc:added', { detail: { trigger: addVar } }));
        })
        .catch(function (err) { flash(err.message, true); })
        .finally(function () { addVar.classList.remove('is-loading'); });
      return;
    }
    var addCol = e.target.closest('[data-jc-add-colour]');
    if (addCol && buy) {
      e.preventDefault();
      addCol.classList.add('is-loading');
      track('inline_add', { colour: addCol.getAttribute('data-jc-add-colour') });
      buy.addColour(addCol.getAttribute('data-jc-add-colour'), addCol, true)
        .catch(function (err) { flash(err.message, true); })
        .finally(function () { addCol.classList.remove('is-loading'); });
      return;
    }

    var so = e.target.closest('[data-jc-story-open]');
    if (so && viewer) {
      e.preventDefault();
      viewer.open(parseInt(so.getAttribute('data-jc-story-open'), 10) || 0,
        so.classList.contains('jc-mo__rbtn') ? 'ring' : so.classList.contains('jc-mo__open') ? 'card' : so.classList.contains('jc-bubble-open') ? 'bubble' : null);
      return;
    }


    var opener = e.target.closest('[data-jc-open-dialog]');
    if (opener) {
      var dlg = document.getElementById(opener.getAttribute('data-jc-open-dialog'));
      if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); if (dlg.hasAttribute('data-jc-lineup-sheet') && state.colour) $$('[data-jc-lineup]', dlg).forEach(function (s) { lineupSelect(s, state.colour, false); }); }
      return;
    }
    var closer = e.target.closest('[data-jc-close-dialog]');
    if (closer) { var cd = closer.closest('dialog'); if (cd) cd.close(); return; }
    if (e.target.tagName === 'DIALOG' && !e.target.hasAttribute('data-jc-stories-viewer')) { e.target.close(); return; }

    var sibAdd = e.target.closest('[data-jc-sib-add]');
    if (sibAdd) {
      var vid = parseInt(sibAdd.getAttribute('data-jc-sib-add'), 10);
      if (!vid || sibAdd.classList.contains('is-loading')) return;
      sibAdd.classList.add('is-loading');
      buzz();
      newLine = vid;
      addLines([{ id: vid, quantity: 1 }], sibAdd).then(function () {
        // 6. The drawer re-rendered under her: keep Tab inside it, on the bag she just added
        var dr = cartDrawer(), inner = dr && dr.querySelector('.drawer__inner');
        if (inner && typeof window.trapFocus === 'function' && dr.classList.contains('active')) {
          var line = dr.querySelector('[data-jc-line-variant="' + vid + '"] .jc-line__name'); // a link, so no keyboard pops up
          window.trapFocus(inner, line || inner);
        }
      }).catch(function (err) {
        newLine = null;
        var box = document.getElementById('CartDrawer-CartErrors'); if (box) box.textContent = err.message;
      }).finally(function () { sibAdd.classList.remove('is-loading'); });
    }
  });

  /* ---------- init ---------- */
  function init(scope) {
    scope = scope || document;
    $$('product-component.jc-product', scope).forEach(function (p) { initBuy(p); initGallery(p); initBuyCol(p); initProof(p); });
    if (scope.matches && scope.matches('product-component.jc-product')) { initBuy(scope); initGallery(scope); initBuyCol(scope); initProof(scope); }
    initEta(scope);
    initAnn(scope);
    initActual(scope);
    initReal(scope);
    initViewer();
    initBubble(scope);
    initDrag(scope);
    initDay(scope);
    initSave(scope);
    initDrawer();
    fillUsd(scope);
    if (state.colour) $$('[data-jc-lineup]', scope).forEach(function (s) { lineupSelect(s, state.colour, false); });
  }

  window.addEventListener('hashchange', openHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); openHash(); });
  else { init(); openHash(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
